import { useState } from "react";

import type { ApiKeyWithSecret } from "@repo/shared";

/**
 * Zeigt das Klartext-Token genau einmal an – im Backend liegt nur der Hash,
 * ein zweites Anzeigen ist technisch nicht möglich.
 */
export function NewKeyDialog({
  apiKey,
  onClose,
}: {
  apiKey: ApiKeyWithSecret;
  onClose: () => void;
}) {
  const [copied, setCopied] = useState(false);

  async function copy() {
    try {
      await navigator.clipboard.writeText(apiKey.token);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      setCopied(false);
    }
  }

  return (
    <div className="callout">
      <strong>API-Key „{apiKey.name}“ erstellt</strong>
      <p className="muted small">
        Kopiere das Token jetzt – es wird nur gehasht gespeichert und später nicht mehr angezeigt.
      </p>
      <code className="token">{apiKey.token}</code>
      <div className="actions">
        <button type="button" onClick={() => void copy()}>
          {copied ? "Kopiert" : "Kopieren"}
        </button>
        <button type="button" onClick={onClose}>
          Schließen
        </button>
      </div>
    </div>
  );
}
